import axios from "axios";
import api from "../api";


export default {

CREATE_PROPERTY: (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(process.env.REACT_APP_BACKEND_URL + api.property.CREATE_PROPERTY(), data)
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},

GET_ALL_PROPERTY: () => {
    return new Promise((resolve, reject) => {
        axios
            .get(process.env.REACT_APP_BACKEND_URL + api.property.GET_ALL_PROPERTY())
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},
UPDATE_PROPERTY: (id,data) => {
    return new Promise((resolve, reject) => {
        axios
            .put(process.env.REACT_APP_BACKEND_URL + api.property.UPDATE_PROPERTY(id),data)
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},
GET_PROPERTY_BY_ID: (id) => {
    return new Promise((resolve, reject) => {
        axios
            .get(process.env.REACT_APP_BACKEND_URL + api.property.GET_PROPERTY_BY_ID(id))
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},


DELETE_PROPERTY: (id) => {
    return new Promise((resolve, reject) => {
        axios
            .delete(process.env.REACT_APP_BACKEND_URL + api.property.DELETE_PROPERTY(id))
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},


GET_PROPERTY_BY_BOARD_ID: (id) => {
    return new Promise((resolve, reject) => {
        axios
            .get(process.env.REACT_APP_BACKEND_URL + api.property.GET_PROPERTY_BY_BOARD_ID(id))
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},

}

